<div class="radio-group-container" [ngClass]="getLevelClass()">
  <div
    [class.radio-group__inner-container]="!errorMessage[prop] && !isDisabled"
    [class.radio-group__inner-container--error]="errorMessage[prop] && !isDisabled"
  >
    <div class="radio-group__label" *ngIf="showTitle">
      <basic-label [noIndent]="true" [ngClass]="{ 'radio-group--readonly': isReadonly }"></basic-label>
    </div>
    <div class="radio-group" [ngClass]="getModifierClasses()">
      <div
        *ngFor="let option of options; let i = index"
        class="radio-button"
        [class.radio-button--text]="option.isDateInput || option.isTextInput"
      >
        <input
          class="radio-button__input"
          type="radio"
          id="{{ radioGroupName }}-choice-{{ i }}"
          name="{{ radioGroupName }}"
          [attr.name]="radioGroupName"
          [(ngModel)]="selectedItem"
          value="{{ option.value }}"
          (ngModelChange)="trigger()"
          (blur)="handleBlur()"
          [required]="!questionItem.optional"
          [disabled]="isServer || isDisabled"
        />

        <label class="radio-button__label" for="{{ radioGroupName }}-choice-{{ i }}">
          <basic-text-input
            [disableConditionally]="!option.isEnabled"
            *ngIf="option.isDateInput"
            [propertyName]="questionItem.subProperty"
            [extraClasses]="['medium']"
            [hideLabel]="true"
            [placeholder]="'mm/yyyy'"
            [parserType]="'ShortDate'"
            [formatterType]="'date_mmyyyy'"
            [inputMask]="mask"
          ></basic-text-input>

          <div class="radio-button__description">{{ option.beforeInputDescription }}</div>
          <basic-text-input
            class="radio-button__text-input"
            [disableConditionally]="!option.isEnabled"
            *ngIf="option.isTextInput"
            [extraClasses]="['small']"
            [propertyName]="questionItem.subProperty"
            [hideLabel]="true"
            [isSandwich]="option.isSandwich"
            [placeholder]="''"
          ></basic-text-input>
          <div class="radio-button__description">{{ option.description }}</div>
        </label>
      </div>
    </div>
  </div>
  <p class="error-message error-message--entry-field" *ngIf="errorMessage[prop] && !isDisabled">
    {{ errorMessage[prop] }}
  </p>
  <alert
    [isOpen]="warningMessage[prop] && !isDisabled"
    [intent]="alertIntent.INFO"
    [hasCloseButton]="true"
    (onClose)="clearWarningMessage()"
  >
    {{ warningMessage[prop] }}
  </alert>
</div>
